var _excluded = ["children", "color", "outline", "type", "withLoader", "loading", "loaderText", "className", "loaderColor"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import { Button } from "reactstrap";
import { Loader } from "../components";
var CustomButton = function CustomButton(_ref) {
  var children = _ref.children,
    color = _ref.color,
    outline = _ref.outline,
    type = _ref.type,
    withLoader = _ref.withLoader,
    loading = _ref.loading,
    loaderText = _ref.loaderText,
    className = _ref.className,
    loaderColor = _ref.loaderColor,
    rest = _objectWithoutProperties(_ref, _excluded);
  var nurturePinkClass = color === 'nurture-pink' && !outline ? 'btn-nurture-pink' : '';
  var nurtureGreenClass = color === 'nurture-green' && !outline ? 'btn-nurture-green' : '';
  var nurturePurpleClass = color === 'nurture-purple' && !outline ? 'btn-nurture-purple' : '';
  var nurtureOrangeClass = color === 'nurture-orange' && !outline ? 'btn-nurture-orange' : '';
  var nurtureClasses = "".concat(nurturePinkClass, " ").concat(nurtureGreenClass, " ").concat(nurturePurpleClass, " ").concat(nurtureOrangeClass);
  return /*#__PURE__*/React.createElement(Button, Object.assign({}, rest, {
    className: "".concat(withLoader ? 'd-inline-flex align-items-center' : '', " ").concat(className, " ").concat(nurtureClasses).trim(),
    outline: outline,
    type: type,
    color: color
  }), withLoader && loading && loaderText ? loaderText : children, withLoader && /*#__PURE__*/React.createElement(Loader, {
    className: "ms-2",
    color: loaderColor,
    loading: loading
  }));
};
CustomButton.defaultProps = {
  type: 'button',
  outline: false,
  color: 'nurture-purple',
  withLoader: false,
  loading: false,
  className: '',
  loaderText: undefined,
  loaderColor: '#ffffff'
};
export default CustomButton;